import { render, staticRenderFns } from "./DevChoose.vue?vue&type=template&id=4f0924c5&scoped=true"
import script from "./DevChoose.vue?vue&type=script&lang=js"
export * from "./DevChoose.vue?vue&type=script&lang=js"
import style0 from "./DevChoose.vue?vue&type=style&index=0&id=4f0924c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0924c5",
  null
  
)

export default component.exports